<template>
  <div>
    <el-button type="success" @click="dialogVisible = true">
      <span>生成兑换码</span>
    </el-button>
    <el-dialog title="生成邀请码" :visible.sync="dialogVisible">
      <div>
        <el-form :inline="true" :model="formFuzzy" label-width="80px">
          <el-form-item label="数量:">
            <el-input
              v-model="formFuzzy.couponCount"
              placeholder="输入领取数量"
              type="number"
              style="width: 180px"
              :step="1"
              step-strictly
              onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input>
          </el-form-item>
        </el-form>
        <br />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="dialogConfirm"
          v-preventReClick
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";

export default {
  name: "getCoupon",
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      formFuzzy: {
        couponCount: "",
        bind: "none", // 来源
      },
      queryData: [],
      multipleSelection: [],
      type: [],
    };
  },
  created() {
    // this.fetchQueryData();
  },
  props: {
    doWhatTemp: {},
  },
  watch: {},
  methods: {
    dialogConfirm() {
      if (this.formFuzzy.couponCount < 1) {
        alert("请输入大于0的整数");
        return;
      }
      let getCount = this.formFuzzy.couponCount;
      if (getCount <= 0) {
        alert("领取数量必须大于0");
        return;
      }

      console.log("kris -- ", this.doWhatTemp.total);
      if (getCount > this.doWhatTemp.total) {
        alert("领取数量超过优惠券总数");
        return;
      }
      this.$emit("inputuFinish", this.formFuzzy);
      this.formFuzzy = {
        couponCount: "",
        bind: "none", // 来源
      };
      this.loading = false;
      this.dialogVisible = false;
    },
  },
  directives: {
    preventReClick: {
      inserted(el, binding) {
        console.log("binding-7", binding);
        el.addEventListener("click", () => {
          if (!el.disabled) {
            el.disabled = true;
            setTimeout(() => {
              el.disabled = false;
            }, binding.value || 1000);
          }
        });
      },
    },
  },
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// getCoupon.vue?7a8c1cd6